/**
 * Object xử lý event global trên toàn bộ hệ thống
 * @author DNThang - 17.03.2020
 * HTHIEP migrate sang vue3
 */
import emitter from 'tiny-emitter/instance';

export default {
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args),
};

/**
 * Đối tượng liệt kê các global event đang có
 * Bắt buộc có globalEvent nào đều phải cấu hình vào đây để không bị trùng tên
 * @author DNThang - 17.03.2020
 */
const GlobalEventName = {
  /**
   * Xử lý đóng tất form
   */
  closeAllPopup: 'closeAllPopup',
  scrollEvent: 'scrollEvent',
  reloadList: 'reloadList',
  resetPopupCenter: 'resetPopupCenter',
  setWaitingConfirm: 'setWaitingConfirm',
  showHelpViewHistory: 'showHelpViewHistory',
  sortEvent: 'showHelpViewHistory',
  updateNotification: 'updateNotification',
  closeAllDropdown: 'closeAllDropdown',
  checkTaxDeclarationProcedure: 'checkTaxDeclarationProcedure',
  checkTaxPaymentProcedure: 'checkTaxPaymentProcedure',
  /**
   * Phục vụ cho việc hiện thị phím tắt ở bên dưới form
   * NNLAM
   */
  controlFocus: 'controlFocus',
  controlBlur: 'controlBlur',
  gridFocus: 'gridFocus',
  gridBlur: 'gridBlur',
  gridReload: 'gridReload',

  //Cất phân quyền
  savePermission: 'savePermission',
  updatePermission: 'updatePermission',
  unMaskWhenMounted: 'unMaskWhenMounted',

  // thông báo
  raiseNotification: 'raiseNotification',
  raiseKBDTNotification: 'raiseKBDTNotification',
  raiseLiveChatNotification: 'raiseLiveChatNotification',
  raiseTT23Notification: 'raiseTT23Notification',
  raiseTT24Notification: 'raiseTT24Notification',
  raiseFinalcialInvoiceNotification: 'raiseFinalcialInvoiceNotification',
  raiseZoomNotification: 'raiseZoomNotification',
  raiseMsTour: 'raiseMsTour',
  raiseShowMsTourInitialInformationDeclaration: 'raiseShowMsTourInitialInformationDeclaration',
  // Bảng đối chiếu
  submitDataDCSD: 'submitDataDCSD',
  natigateToProcess: 'natigateToProcess',
  // Đổi database
  changeDatabase: 'changeDatabase',
  changeDatabaseByName: 'changeDatabaseByName',
  changeDatabaseById: 'changeDatabaseById',
  // Load tenant databases
  loadDatabase: 'loadDatabase',
  loadDatabaseManagement: 'loadDatabaseManagement',

  openWrapper: 'openWrapper',
  // Thay đổi phụ giảm thuế (NHANH3 01.07.2024)
  changeTaxReductionAppendix: 'changeTaxReductionAppendix',

  //Show popup cập nhật TT 24/2024/TT-BTC
  showConversionOfAccountingSystemPopup: 'showConversionOfAccountingSystemPopup',

  //Callback function sau khi đóng popup cập nhật TT 24/2024/TT-BTC
  afterHideConversionOfAccountingSystemPopup: 'afterHideConversionOfAccountingSystemPopup',

  //Mở dữ liệu trên tab mới
  openDatabaseOnNewTab: 'openDatabaseOnNewTab',

  // MISA Platform (MPL): báo hiệu MISACore đã load + init xong (quicklauncher sẵn sàng),
  // để TopNav.vue init tiếp UserControlPanel (avatar + notification)
  mplCoreReady: 'mplCoreReady',
};

export {GlobalEventName};
